import { Button } from "@atgis/ui";
import { ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { ThemeToggle } from "./ThemeToggle";

const NAV = [
  { href: "#kimler-icin", label: "Kimler İçin" },
  { href: "#urun", label: "Ürün" },
  { href: "#changeset", label: "Onay Akışı" },
  { href: "#is-takip", label: "İş Takibi" },
  { href: "#simulasyon", label: "Simülasyon" },
  { href: "#cad", label: "CAD" },
  { href: "#fiyat", label: "Planlar" },
];

export function Header() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-border/60 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between gap-6">
        <a href="#" className="flex items-center" aria-label="RADGIS ana sayfa">
          <Logo />
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Button variant="ghost" size="sm" asChild className="hidden sm:inline-flex">
            <a href="#iletisim">Demo İste</a>
          </Button>
          <Button size="sm" asChild>
            <a href="#iletisim">
              Platforma Geç <ArrowRight />
            </a>
          </Button>
        </div>
      </div>
    </header>
  );
}
